/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Upload } from '../model';
/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a dict with the original filename and temporary location on S3. This data can then be used when creating or updating objects with the file data
         * @summary Upload files temporary
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {any} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: async (aaSource?: string, files?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a dict with the original filename and temporary location on S3. This data can then be used when creating or updating objects with the file data
         * @summary Upload files temporary
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {any} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload(aaSource?: string, files?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Upload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUpload(aaSource, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * Returns a dict with the original filename and temporary location on S3. This data can then be used when creating or updating objects with the file data
         * @summary Upload files temporary
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {any} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload(aaSource?: string, files?: any, options?: any): AxiosPromise<Upload> {
            return localVarFp.fileUpload(aaSource, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for fileUpload operation in FilesApi.
 * @export
 * @interface FilesApiFileUploadRequest
 */
export interface FilesApiFileUploadRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof FilesApiFileUpload
     */
    readonly aaSource?: string

    /**
     * 
     * @type {any}
     * @memberof FilesApiFileUpload
     */
    readonly files?: any
}

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * Returns a dict with the original filename and temporary location on S3. This data can then be used when creating or updating objects with the file data
     * @summary Upload files temporary
     * @param {FilesApiFileUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public fileUpload(requestParameters: FilesApiFileUploadRequest = {}, options?: any) {
        return FilesApiFp(this.configuration).fileUpload(requestParameters.aaSource, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }
}
